import { observer } from 'mobx-react-lite';
import { Modal, ModalProps } from '../modal';

import './providerDetailsModal.styl';
import { useStoreContext } from 'store/app';
import { useTranslationsContext } from 'store/translations';
import { useEffect } from 'react';
import { sanitize } from 'dompurify';

interface Props extends ModalProps {
    text: string;
    rewardId?: string;
    missionId?: string;
}

export const ProviderDetailsModal = observer(({ rewardId, text, missionId, ...rest }: Props) => {
    const { logOperation } = useStoreContext();
    const { translate } = useTranslationsContext();

    useEffect(() => {
        rewardId && logOperation('rewards', 'provider_view', rewardId);
        missionId != null && logOperation('missions', 'provider_view', missionId);
    }, [rewardId]);

    if (!text) {
        return null;
    }

    return (
        <Modal title={translate('provider.details.title')} {...rest}>
            <div className="provider-details-modal" dangerouslySetInnerHTML={{ __html: sanitize(text) }}></div>
        </Modal>
    );
});
